import React, {useState,useImperativeHandle,forwardRef} from 'react'
import {Modal, Button, Input, message} from 'antd'
import Tools from '../tools/Tools'

function SendInstructModal(props,ref) {
    const [visible,setVisible] = useState(false)
    const [password,setPassword] = useState('')
    const [instructObj,setInstructObj] = useState({})

    useImperativeHandle(ref, () => ({
        showModal: (obj) => {
            setVisible(true)
            setInstructObj(obj)
        }
    }))

    function hideModal() {
        setVisible(false)
        setPassword('')
    }

    function handleOk() {
        let url = `/rest/instruction/task/resend`
        if (!password) {
            message.error(Strings.rs10396)
            return
        }
        let model = {
            id: instructObj.taskDetailId,
            password:hex_md5(password)
        }
        Tools.fetch(url,'POST',model,function (data) {
            if(data.code == 0){
                message.success(Strings.rs10358)
                hideModal()
            } else {
                message.error(data.message)
            }
        })
    }

    return  <Modal transitionName="" maskTransitionName=""
                   className="default_modal wid439"
                   width=""
                   destroyOnClose={true}
                   visible={visible}
                   onCancel={hideModal}
                   maskClosable={false}
                   title={Strings.rs10357}
                   footer={null}>
        <div className={"modal_item"}>
            <span className="form_span">{Strings.rs10099}</span>
            <div className={"form_value"}>{instructObj.instructionName}</div>
        </div>
        <div className={"modal_item"}>
            <span className="form_span">{Strings.rs10106}</span>
            <div className={"form_value"}>{Strings.rs14384}</div>
        </div>
        <div className={"modal_item"}>
            <span className="form_span">{Strings.rs10065}</span>
            <div className={"form_value"}>{instructObj.deviceNum}</div>
        </div>
        <div className={"modal_item"}>
            <span className="form_span min_wid115">{Strings.rs10037}</span>
            <div className={"form_value"}>
                <Input value={password} type={"password"} autoComplete='new-password'
                       onChange={(e)=>setPassword(e.target.value.trim())}
                       placeholder={Strings.rs10396} maxLength={32}/>
            </div>
        </div>
        <div className="btn-row mg_top24">
            <Button className="mg_right10" onClick={hideModal}>{Strings.rs10054}</Button>
            <Button type='primary' onClick={handleOk}>{Strings.rs10058}</Button>
        </div>
    </Modal>
}
export default forwardRef(SendInstructModal)